module.exports = __webpack_public_path__ + "media/images/japan/horizontal_rule-069ab53d90a1a575d0ad07c1117dbba6.svg";